<div class="breadcrumb flex align-center" aria-label="breadcrumb">
  <ng-container
    *ngFor="let breadcrumb of breadcrumbs$ | async; first as isFirst; trackBy: trackByLevel"
  >
    <span *ngIf="!isFirst" class="breadcrumb__separator  h6 mb-0 mx-2" aria-hidden="true">/</span>

    <span
      class="breadcrumb__item d-inline-flex align-center h6 mb-0 weight-medium"
      [class.breadcrumb__item--last]="breadcrumb.isCurrent"
    >
      <ng-container
        *ngTemplateOutlet="
        breadcrumb.isCurrent ? lastRoute : (breadcrumb.url ? route : pendingRoute);
        context:{breadcrumb: breadcrumb}"
      ></ng-container>
    </span>
  </ng-container>

  <span class="breadcrumb__suffix d-inline-flex align-center ml-2"><ng-content></ng-content></span>
</div>

<ng-template #lastRoute let-breadcrumb="breadcrumb">
  <span class="breadcrumb__route d-inline-flex align-center text-undecorated text-primary-dark" aria-current="page">
    <ng-container *ngTemplateOutlet="routeContent; context: {breadcrumb: breadcrumb}"></ng-container>
  </span>
</ng-template>

<!-- an owning record whose id has not arrived yet: shown so the trail never shifts, but not yet
     linkable, because the only id available at this point belongs to a different record. -->
<ng-template #pendingRoute let-breadcrumb="breadcrumb">
  <span class="breadcrumb__route d-inline-flex align-center text-undecorated">
    <ng-container *ngTemplateOutlet="routeContent; context: {breadcrumb: breadcrumb}"></ng-container>
  </span>
</ng-template>

<ng-template #route let-breadcrumb="breadcrumb">
  <a
    class="breadcrumb__route d-inline-flex align-center text-undecorated"
    [routerLink]="breadcrumb.url"
  >
    <ng-container *ngTemplateOutlet="routeContent; context: {breadcrumb: breadcrumb}"></ng-container>
  </a>
</ng-template>

<ng-template #routeContent let-breadcrumb="breadcrumb">
  <span class="breadcrumb__route-label text-ellipsis text-nowrap">{{ breadcrumb.label }}</span>
</ng-template>
